import { KIND_LABELS } from "./nodeInspectorConstants";

function reparentTargetLabel(n) {
  if (!n) return "(missing)";
  if (n.label && n.label.trim().length > 0) return n.label;
  if (n.kind === "retry") return `Retry \u00d7 ${n.maxAttempts}`;
  if (n.kind === "repeat") return `Repeat \u00d7 ${n.count}`;
  if (n.kind === "ifThenElse") return "If / Then / Else";
  return KIND_LABELS[n.kind] || n.kind;
}

export { reparentTargetLabel };
